import { axios } from "../../util/axiosConfig";
import { cities } from "../urls";

const getCityImage = imageName =>
  axios.get(cities.logo(imageName)).then(response => "data:image/*;base64," + response.data);

export default getCityImage;
